import React from 'react';
import Topbar from './components/Topbar';
import Home from './components/Home';
import Skills from './components/Skills';
import './App.css';
import About from './components/About';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Certifications from './components/Certification';
function App() {
  return (
    <div className="App">
      <Topbar />
      <Home id="home" />
      <About id="about" />
      <Skills id="skills" />
      
      <Certifications id="certifications"/>
      <Projects id="projects" />
      <Contact id="contact" />
    </div>
  );
}

export default App;
